import React, { useEffect, useState } from 'react';
import { RutasPrivadas } from '../../../../../routes/rutasPrivadas/rutasPrivadas';
import { obtenerTodosUsuarios } from '../../../../../actions/user/user.actions';
import { useNavigate } from 'react-router-dom';
import { listaUsuarios } from '../../../../../models/usuarios/usuarios.models';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

export type UsuariosScreenProps = {
	// types...
}

const UsuariosScreen: React.FC<UsuariosScreenProps> = ({ }) => {
	const [loading, setLoading] = useState<boolean>(true);
	const [listaUsuarios, setListaUsuarios] = useState<listaUsuarios[]>([]);
	const navigate = useNavigate();

	async function obtenerUsuariosAsync() {
		try {
			const resp = await obtenerTodosUsuarios();
			let usuarios: listaUsuarios[] = resp.data;
			const listaUsuariosFiltrada: listaUsuarios[] = usuarios.filter((usuario) => (usuario.datosCompletos /*|| !usuario.datosCompletosEmpresaDefault || !usuario.empresaRegistrada*/));
			setListaUsuarios(listaUsuariosFiltrada);
			setLoading(false)
		} catch (err) {
			console.error(err);
		}
	}

	function navegarA(idUsuario: number) {
		navigate(`/dashboard/todos_usuarios/${RutasPrivadas.DATOS_USUARIO}/${idUsuario}/editar`, { replace: true })
	}

	useEffect(() => {
		obtenerUsuariosAsync();
	}, [])

	return (
		<div className='flex flex-col gap-4 p-5 bg-white w-full border shadow-xl rounded-xl h-[85%] overflow-y-hidden'>
			{/* title */}
			<div>
				<div className='flex flex-row gap-2 justify-between pl-2'>
					<p className='font-medium lg:text-2xl md:text-lg text-base text-DegradatedText'>
						Usuarios.
					</p>
				</div>
			</div>
			{/* content */}
			<div className='flex gap-2 overflow-y-auto'>
				{
					loading ?
					<div className={`max-h-full overflow-auto m-2 pt-2 w-full border`}>
						{
							
							<div className='flex justify-center pt-5 pb-5'>
								<h1 className='font-semibold text-xl'> Obteniendo datos ...</h1>
							</div>
							
						}
					</div> :
					<div className={`max-h-full overflow-auto m-2 pt-2 w-full border`}>
					{
						!listaUsuarios.length ? (
							<div className='flex justify-center pt-5 pb-5'>
								<h1 className='font-semibold text-xl'>Sin información</h1>
							</div>
						) :
						(
							<table className='table table-zebra border-DarkBlue table-md table-pin-rows table-pin-cols bg-white text-center'>
								<thead>
									<tr className='text-black'>
										<th>ID Elsa</th>
										<th>Nombre</th>
										<th>Apellidos</th>
										<th>Correo</th>
										<th>Registro finalizado</th>
										<th>Acciones</th>
									</tr>
								</thead>
								<tbody>
									{
										listaUsuarios.length > 0 && listaUsuarios.map(
											(usuario, index) => (
												<tr key={index}>
													<td>
														{usuario.idUsuarioElsa}
													</td>
													<td>
														{usuario.nombreCompleto}
													</td>
													<td>
														{usuario.primerApellido}
													</td>
													<td>
														{usuario.correo}
													</td>
													<td className={`p-2 ${usuario.datosCompletos && usuario.empresaRegistrada ? 'bg-green-500' : usuario.datosCompletos && !usuario.empresaRegistrada ? 'bg-orange-500' : 'bg-red-500'}`}>
														<p className=' font-semibold text-black'>
															{usuario.datosCompletos && usuario.empresaRegistrada ? 'Registro finalizado' : usuario.datosCompletos && !usuario.empresaRegistrada ? 'Requiere finalizar registro' : 'Datos incompletos'}
														</p>
													</td>
													<td className='flex flex-row gap-4 items-center justify-center text-base'>
														<button onClick={() => navegarA(usuario.idUsuarioElsa)}>
															<FontAwesomeIcon icon={faEdit} />
														</button>
													</td>
												</tr>
											)
										)
									}
								</tbody>
							</table>
						)
					}
					</div>

				}
				
			</div>
		</div>
	);
};

export default UsuariosScreen;
